import React, { useState, useEffect } from "react"
import { useLocation } from "react-router"
import { confirmPayment } from "../../utils/ApiRequests"
import MiniLoader from "../../components/Loaders/MiniLoader"
import { IoCheckmarkDoneCircle } from "react-icons/io5"
import { MdError } from "react-icons/md"
import Navbar from "../../components/Navbar/Navbar"
import { useCart } from "react-use-cart"

const Confirmation = () => {
  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const { emptyCart } = useCart()
  const { search } = useLocation()

  const query = new URLSearchParams(search)
  const referenceCode = query.get("reference")
  const transactionRef = query.get("trxref")

  // console.log(referenceCode)
  // console.log("trxref:", transactionRef)

  useEffect(() => {
    confirmPayment(transactionRef, referenceCode)
      .then(res => {
        console.log(res.data)
        setSuccess(true)
        setLoading(false)
        emptyCart()
        localStorage.removeItem("checkout")
        localStorage.removeItem("regLoc")
      })
      .catch(error => {
        setLoading(false)
        setError(true)
        console.log(error.response.data.message)
        setErrorMessage(error.response.data.message)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referenceCode, transactionRef])

  const paymentResponse = loading ? (
    "Confirming your payment"
  ) : success ? (
    // ? "Payment Successfull"
    <>
      <div className="payment-response text-center">
        <h1>Payment Successfull</h1>
        <p style={{ fontSize: "18px" }}>
          You have successfully payed for the gift items,{" "}
          <a
            style={{ textDecoration: "underline", color: "#0954ff" }}
            href="/find-registry"
          >
            {" "}
            see other registries
          </a>{" "}
          or{" "}
          <a style={{ textDecoration: "underline", color: "#0954ff" }} href="/">
            {" "}
            go home
          </a>{" "}
        </p>
      </div>
    </>
  ) : error ? (
    errorMessage
  ) : (
    ""
  )

  const icon = loading ? (
    <MiniLoader />
  ) : success ? (
    <IoCheckmarkDoneCircle
      style={{ margin: "auto", fontSize: "60px", color: "green" }}
    />
  ) : error ? (
    <MdError style={{ margin: "auto", fontSize: "60px", color: "red" }} />
  ) : (
    ""
  )

  return (
    <>
      <Navbar />
      <div className="global-container py-10">
        <div className="confirmation__wrapper centered-content ">
          {icon}
          <div className="content text-xl">{paymentResponse}</div>
        </div>
      </div>
    </>
  )
}

export default Confirmation
